import React, { useEffect, useState } from "react";
import { instance2 } from "../../utils/axiosInstance";
import { ReactComponent as BackButton } from "../../img/bacbuttonicon.svg";
import { formatNumber } from "src/components/numberingformat";

export default function TambahKonsumen(){

  const [categoriesTambah, setCategoriesTambah] = useState([]);
        const [loadingCategories, setLoadingCategories] = useState(false);
        const [categoriesError, setCategoriesError] = useState(null);

  const [schoolGrade, setSchoolGrade] = useState([]);
        const [loadingSchoolGrade, setLoadingSchoolGrade] = useState(false);
        const [schoolGradeError, setSchoolGradeError] = useState(null);
const [clusters, setClusters] = useState([]);

      const [formDataTambah, setFormDataTambah] = useState({
  name: "",
  kitchen_id: localStorage.getItem("kitchenId"),
  pack: "0",
  type_id: "",
  school_level_id: "",
  address: "",
  delivery: "",
  admin_id: localStorage.getItem("userAuthentication"),
});

const [deliveryOptions, setDeliveryOptions] = useState([]);
const [loadingDeliveryOptions, setLoadingDeliveryOptions] = useState(true);

useEffect(() => {
  const fetchDeliveryOptions = async () => {
    try {
      const response = await instance2.get("customers/delivery_master");
      const options = response.data || [];
      setDeliveryOptions(options);

      // Set default delivery ID = 1 if not already set
      if (!formDataTambah.delivery) {
        setFormDataTambah((prev) => ({
          ...prev,
          delivery: "1", // Default to ID 1
        }));
      }
    } catch (error) {
      console.error("Error fetching delivery options:", error);
    } finally {
      setLoadingDeliveryOptions(false);
    }
  };

  fetchDeliveryOptions();
}, []);


const prevTypeId = React.useRef();
const prevGradeId = React.useRef();

useEffect(() => {
  if (prevTypeId.current !== formDataTambah.type_id) {
    const cleared = { ...formDataTambah, school_level_id: "", pack: "0" };

    clusters.forEach((cluster) => {
      cleared[cluster.code] = "";
    });

    setFormDataTambah(cleared);
    prevTypeId.current = formDataTambah.type_id;
  }
}, [formDataTambah.type_id, clusters]);

useEffect(() => {
  if (prevGradeId.current !== formDataTambah.school_level_id) {
    const cleared = { ...formDataTambah, pack: "0" };

    clusters.forEach((cluster) => {
      cleared[cluster.code] = "";
    });

    setFormDataTambah(cleared);
    prevGradeId.current = formDataTambah.school_level_id;
  }
}, [formDataTambah.school_level_id, clusters]);


useEffect(() => {
  const fetchClusters = async () => {
    try {
      const response = await instance2.get("customers/clusters");
      setClusters(response.data?.data || response.data || []);
    } catch (err) {
      console.error("Failed to fetch clusters", err);
    }
  };

  fetchClusters();
}, []);

const filteredClusters = clusters.filter((cluster) => {
  const groupMatches = cluster.group_id.toString() === formDataTambah.type_id;

  if (formDataTambah.type_id === "1") {
    return groupMatches && cluster.level_id?.toString() === formDataTambah.school_level_id;
  }

  return groupMatches;
});

useEffect(() => {
  // Set default delivery "1" for each cluster if not already set
  const updatedDelivery = { ...formDataTambah };
  let changed = false;

  filteredClusters.forEach((cluster) => {
    const key = `delivery_${cluster.id}`;
    if (!updatedDelivery[key]) {
      updatedDelivery[key] = "1"; // default to 'Pagi'
      changed = true;
    }
  });

  if (changed) {
    setFormDataTambah(updatedDelivery);
  }
}, [filteredClusters]);


      useEffect(() => {
        const fetchCategories = async () => {
          try {
            setLoadingCategories(true);
            setCategoriesError(null);
            // Replace 'categories' with your actual API endpoint for categories
            const response = await instance2.get("customers/types");
            const apiCategories = response.data?.data || response.data || [];
            setCategoriesTambah(apiCategories);
          } catch (error) {
            console.error("Error fetching categories:", error);
            setCategoriesError(error.message || "Failed to fetch categories");
          } finally {
            setLoadingCategories(false);
          }
        };
      
        fetchCategories();
      }, []);

            useEffect(() => {
        const fetchSchoolGrades = async () => {
          try {
            setLoadingSchoolGrade(true);
            setSchoolGradeError(null);
            // Replace 'categories' with your actual API endpoint for categories
            const response = await instance2.get("customers/school_master");
            const apiCategories = response.data?.data || response.data || [];
            setSchoolGrade(apiCategories);
          } catch (error) {
            console.error("Error fetching categories:", error);
            setSchoolGradeError(error.message || "Failed to fetch school grades");
          } finally {
            setLoadingSchoolGrade(false);
          }
        };
      
        fetchSchoolGrades();
      }, []);

const handleChange = (e) => {
  const { name, value } = e.target;

  const transformedValue =
    name === "name"
      ? value
          .split(" ")
          .map((word) =>
            word.length > 0
              ?  word.slice(0).toUpperCase()
              : ""
          )
          .join(" ")
      : value;

  setFormDataTambah((prev) => ({
    ...prev,
    [name]: transformedValue,
  }));
};

const prevTotalRef = React.useRef(formDataTambah.pack);

useEffect(() => {
  const total = clusters
    .map((c) => formDataTambah[c.code])
    .reduce((sum, val) => sum + (parseFloat(val) || 0), 0)
    .toString();

  // Hanya setState jika totalnya berubah
  if (prevTotalRef.current !== total) {
    prevTotalRef.current = total;
    setFormDataTambah((prev) => ({
      ...prev,
      pack: total,
    }));
  }
}, [formDataTambah, clusters]);



      
       const handleSubmitTambah = async (e) => {
  e.preventDefault();

  try {
    // Post utama untuk data konsumen
    const response = await instance2.post("customers", formDataTambah);
    const customer_id = response.data[0].id; // pastikan ini ambil ID yang benar

    console.log("Customer added:", response.data);
    console.log("Customer added:", customer_id);

    // Kirim ke customer_clusters per cluster
    const clusterPosts = filteredClusters
      .map((cluster) => {
        const qty = parseFloat(formDataTambah[cluster.code]);
        if (!qty || qty <= 0) return null; // skip jika tidak ada isi / 0

        return instance2.post("/customers/customer_clusters", {
          cluster_id: cluster.id,
          cluster_name: cluster.name,
          customer_id: customer_id,
          qty,
          delivery: formDataTambah[`delivery_${cluster.id}`] || "1", // fallback to default
          admin_id: formDataTambah.admin_id,
        });
      })
      .filter(Boolean); // hapus null

    // Tunggu semua post selesai
    await Promise.all(clusterPosts);

    console.log("All cluster posts completed");

    window.history.back(); // redirect
  } catch (error) {
    console.log("Customer NOT added:", formDataTambah);
    console.error("Error submitting:", error);
  }
};


        const isFormValid = () => {
          return (
            formDataTambah.name !== "" &&
            formDataTambah.pack !== "0" &&
            formDataTambah.address !== "" &&
            formDataTambah.type_id !== ""
          );
        };
        
const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 640); // sm breakpoint
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);
let pelangganSection;

if (isMobile) {
  // Mobile: column layout
  pelangganSection = (
    <div className="flex flex-col w-full gap-4">
      {/* Tipe Penerima Manfaat */}
            <div className="flex flex-row items-center w-full gap-2">
            <label className="block text-gray-700 w-full sm:w-1/4 text-sm">Tipe Penerima Manfaat</label>
        <select
          className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
          value={formDataTambah.type_id}
          onChange={(e) =>
            setFormDataTambah({ ...formDataTambah, type_id: e.target.value })
          }
        >
          <option value="" disabled>Pilih Kategori</option>
          {categoriesTambah.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div>

      {/* Jenjang Sekolah */}
      {formDataTambah.type_id === "1" && (
            <div className="flex flex-row items-center w-full gap-2">
            <label className="block text-gray-700 w-full sm:w-1/4 text-sm">Jenjang Sekolah</label>
          <select
            className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
            value={formDataTambah.school_level_id}
            onChange={(e) =>
              setFormDataTambah({ ...formDataTambah, school_level_id: e.target.value })
            }
          >
            <option value="" disabled>Pilih Kategori</option>
            {schoolGrade.map((grade) => (
              <option key={grade.id} value={grade.id}>
                {grade.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
} else {
  // Desktop: side-by-side layout
  pelangganSection = (
    <div className="flex flex-row items-center w-full gap-2">
            <label
  className={`block text-gray-700 text-sm ${
    formDataTambah.type_id === "1" ? "w-1/2" : "w-1/4"
  }`}
>
  Tipe Penerima Manfaat
</label>

          <select
            className={`w-full px-3 border-none rounded-[50px] bg-white text-xs py-4 ${formDataTambah.type_id === "1" ? "ml-[5px]" : ""}`}
            value={formDataTambah.type_id}
            onChange={(e) => setFormDataTambah({ ...formDataTambah, type_id: e.target.value })}
          >
            <option value="" disabled>Pilih Kategori</option>
            {categoriesTambah.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name} {/* Assuming API returns 'id' and 'name' */}
              </option>
            ))}
          </select>
           {formDataTambah.type_id === "1" && ( // compare as string if from select
  <div className="flex flex-row items-center w-full gap-2">
    <label className="block text-gray-700 w-full sm:w-1/4 text-sm">Jenjang Sekolah</label>
    <select
      className={`w-full px-3 border-none rounded-[50px] bg-white text-xs py-4 ${formDataTambah.type_id === "1" ? "mr-[5px]" : ""}`}
      value={formDataTambah.school_level_id}
      onChange={(e) => setFormDataTambah({ ...formDataTambah, school_level_id: e.target.value })}
    >
      <option value="" disabled>Pilih Kategori</option>
      {schoolGrade.map((grade) => (
        <option key={grade.id} value={grade.id}>
          {grade.name}
        </option>
      ))}
    </select>
  </div>
)}
          </div>
  );
}

const isAnyLoading = loadingCategories || loadingSchoolGrade || clusters.length === 0;

if (isAnyLoading) {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-red-500 border-solid"></div>
    </div>
  );
} else {
    return(
        <div className="p-4">
        <div className="flex flex-row gap-4 items-center">
          <div className="bg-white p-2 rounded-full cursor-pointer"
              onClick={() => window.history.back()}>
          <BackButton 
          className="rotate-180 text-black" />
          </div>
            <h1 className="block text-black text-xl sm:text-2xl my-2 font-medium">Tambah Konsumen</h1>
            </div>
            
        <div className="flex flex-col w-full items-center">
  <div className="w-full flex justify-center">
    <div className="flex flex-col gap-10 pt-5 mx-5 w-full max-w-3xl items-center justify-center">

         
    {pelangganSection}
            <div className="flex flex-row items-center w-full gap-2">
            <label className="block text-gray-700 w-full sm:w-1/4 text-sm">
              Nama Konsumen
            </label>
            <input
              type="text"
              name="name"
              value={formDataTambah.name}
              onChange={handleChange}
              className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
              placeholder="Nama Konsumen"
            />
            </div>
   
    <div className="flex flex-row items-center w-full gap-2">
          <label className="block text-gray-700 w-full sm:w-1/4 text-sm">Alamat</label>
          
          <input
              type="text"
              name="address"
              value={formDataTambah.address}
              onChange={handleChange}
              className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
              placeholder="Alamat"
            />
          </div>



   {filteredClusters.map((cluster) => {
  const fieldName = cluster.code;

  return (
    <div key={cluster.id} className={`w-full ${isMobile ? "flex flex-col gap-4" : "flex flex-row items-center gap-2"}`}>
      {/* Cluster label and input */}
      <div className={`${isMobile ? "w-full" : "w-1/2"} flex ${isMobile ? "flex-col" : "flex-row items-center"} gap-2`}>
        <label className={`${isMobile ? "" : "w-2/3"} block text-gray-700 text-sm`}>
          {cluster.name} (Cluster {cluster.cluster})
        </label>
        <input
  type="text"
  name={fieldName}
  value={
    formDataTambah[fieldName] !== undefined && formDataTambah[fieldName] !== null
      ? formatNumber(formDataTambah[fieldName])
      : ""
  }
  onChange={(e) => {
    const raw = e.target.value.replace(/\./g, ''); // Hapus titik
    const parsed = parseInt(raw, 10);
    setFormDataTambah((prev) => ({
      ...prev,
      [fieldName]: isNaN(parsed) ? 0 : parsed,
    }));
  }}
  className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
  placeholder="Jumlah Porsi"
/>

      </div>

      {/* Delivery radio buttons */}
      <div className={`${isMobile ? "w-full" : "w-1/2"} flex ${isMobile ? "flex-col" : "flex-row items-center"} gap-4`}>
        <label className={`${isMobile ? "" : "w-1/3"} block text-gray-700 text-sm`}>
          Waktu Pengantaran
        </label>
        <div className={`${isMobile ? "flex flex-row flex-wrap" : "flex gap-4 w-2/3"}`}>
          {deliveryOptions.map((option) => (
            <label key={option.id} className="flex items-center gap-2 text-sm">
              <input
                type="radio"
                name={`delivery_${cluster.id}`}
                value={option.id}
                checked={formDataTambah[`delivery_${cluster.id}`] === option.id.toString()}
                onChange={(e) =>
                  setFormDataTambah((prev) => ({
                    ...prev,
                    [`delivery_${cluster.id}`]: e.target.value,
                  }))
                }
              />
              {option.name}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
})}
<div className="flex flex-row items-center w-full gap-2">
  <label className="block text-gray-700 w-full sm:w-1/5 text-sm">
    Total Jumlah Porsi
  </label>

  <input
  type="text"
  name="pack"
  value={
    formDataTambah.pack !== undefined && formDataTambah.pack !== null
      ? formatNumber(formDataTambah.pack)
      : ""
  }
  disabled
  className="w-full sm:w-2/6 px-3 border-none rounded-[50px] bg-white text-xs py-4"
  placeholder="Jumlah Porsi"
/>

</div>

          </div>
          </div>

          
    
      <div className="w-full flex flex-row sm:flex-row justify-center mt-4 px-4 sm:px-8 gap-5 pb-5">
        <button
        className="bg-merah-no py-5 px-8 text-white rounded-[30px] hover:bg-merah-hover"
          onClick={() => {window.history.back()}}
        >
          Kembali
        </button>
        <button
          onClick={handleSubmitTambah}
              disabled={!isFormValid()}
              className={`py-5 px-8 rounded-[30px] text-sm transition-colors duration-300 ${
                isFormValid()
                  ? "bg-merah-no text-white hover:bg-merah-hover"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
        >
          Tambah Konsumen
        </button>
      </div>
      </div>
        </div>
    )
}
}